import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-530bf50d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-title" }, " CONFIRM BURN REDEEM ", -1))
const _hoisted_2 = { class: "confirm-receipt max-w-xs m-auto" }
const _hoisted_3 = { class: "confirm-summary" }
const _hoisted_4 = { class: "confirm-burn-summary" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg my-1 text-left" }, " BURNING ", -1))
const _hoisted_6 = {
  key: 1,
  class: "confirm-receipt-thumb"
}
const _hoisted_7 = { class: "confirm-receipt-detail" }
const _hoisted_8 = { class: "confirm-receipt-title" }
const _hoisted_9 = { class: "confirm-receipt-creator" }
const _hoisted_10 = { class: "flex flex-col justify-end items-end" }
const _hoisted_11 = { class: "text-xs secondary ml-1 whitespace-nowrap" }
const _hoisted_12 = { class: "confirm-redeem-summary" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg my-1 text-left" }, " RECEIVING ", -1))
const _hoisted_14 = { class: "confirm-receipt-review" }
const _hoisted_15 = { class: "confirm-receipt-detail" }
const _hoisted_16 = { class: "confirm-receipt-title" }
const _hoisted_17 = { class: "confirm-receipt-creator" }
const _hoisted_18 = { class: "flex flex-col justify-end items-end" }
const _hoisted_19 = { class: "text-xs secondary ml-1 whitespace-nowrap" }
const _hoisted_20 = { class: "confirm-receipt-line" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-receipt-line-item label flex items-center content-center justify-center text-md" }, " Price ", -1))
const _hoisted_22 = { class: "confirm-receipt-line-item value" }
const _hoisted_23 = {
  key: 0,
  class: "confirm-receipt-line"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-receipt-line-item label text-mdsm italic text-gray-400" }, " Mint Fee ", -1))
const _hoisted_25 = { class: "confirm-receipt-line-item value italic text-gray-400" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "confirm-br white" }, null, -1))
const _hoisted_27 = { class: "confirm-receipt-line" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-receipt-line-item bold" }, " Total ", -1))
const _hoisted_29 = { class: "confirm-receipt-line-item value bold" }
const _hoisted_30 = { class: "confirm-receipt-line" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_32 = { class: "confirm-receipt-line-item secondary" }
const _hoisted_33 = { class: "confirm-cta" }
const _hoisted_34 = { class: "confirm-cta-subtitle" }
const _hoisted_35 = { class: "confirm-cta-title" }
const _hoisted_36 = { class: "relative overflow-visible" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "relative flex items-center content-center justify-center group text-left" }
const _hoisted_39 = { class: "dot flex items-center" }
const _hoisted_40 = { class: "relative z-10 w-6 h-6 flex items-center justify-center bg-white rounded-full border-white border-solid border-2" }
const _hoisted_41 = { class: "description ml-4 flex flex-col max-w-2xs" }
const _hoisted_42 = { class: "text-sm text-gray-400" }
const _hoisted_43 = ["href"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  class: "relative flex items-center content-center justify-center group text-left",
  "aria-current": "step"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot flex items-center bg-black flex-0",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "border-2 border-white border-solid relative z-10 w-6 h-6 flex items-center justify-center bg-black border-2 border-white rounded-full" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "h-1.5 w-1.5 bg-white rounded-full animate-ping background-black" })
  ])
], -1))
const _hoisted_47 = { class: "description ml-4 flex flex-col max-w-2xs" }
const _hoisted_48 = { class: "text-sm" }
const _hoisted_49 = ["href"]
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { class: "relative flex items-center content-center justify-center group text-left" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot flex items-center",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "relative z-10 w-6 h-6 flex items-center justify-center bg-black border-2 border-solid border-gray-500 rounded-full" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "h-2.5 w-2.5 bg-transparent rounded-full" })
  ])
], -1))
const _hoisted_53 = { class: "description ml-4 flex flex-col max-w-2xs" }
const _hoisted_54 = { class: "text-sm text-gray-500" }
const _hoisted_55 = ["href"]
const _hoisted_56 = {
  key: 1,
  class: "flex flex-row w-full justify-around"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "35",
  height: "35",
  class: "w-full h-full",
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "26.7906",
    y1: "9.40166",
    x2: "9.4015",
    y2: "26.7908",
    stroke: "white",
    "stroke-width": "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "8.73274",
    y1: "8.65633",
    x2: "26.1218",
    y2: "26.0454",
    stroke: "white",
    "stroke-width": "2"
  })
], -1))
const _hoisted_58 = [
  _hoisted_57
]

import { BigNumber } from '@ethersproject/bignumber';
import { formatEther } from '@ethersproject/units';
import {
  computed, onMounted, onUnmounted, ref,
} from 'vue';
import {
  MULTI_BURN_FEE, BURN_FEE, DataClientNFT,
} from '@/common/constants';
import { CheckIcon } from '@heroicons/vue/solid';
import 'vue3-carousel/dist/carousel.css';
import {
  Carousel, Slide, Pagination, Navigation,
} from 'vue3-carousel';
import MediaLoader from '@/components/MediaLoader.vue';
import { abbreviate } from '@/lib/util';
import { EyeOffIcon } from '@heroicons/vue/solid';
import Modal from '@/components/Modal.vue';
import { useBR } from '@/composables/useBR';

type Step = {
  name: string;
  description?: string;
  href?: string;
  status: 'current' | 'next' | 'complete';
};
type ConfirmDialogProps = {
  numberToRedeem: number;
  selectedTokens: DataClientNFT[][];
  redeemTokenImage: string;
  redeemTokenName: string;
  steps: Step[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    numberToRedeem: null,
    selectedTokens: null,
    redeemTokenImage: null,
    redeemTokenName: null,
    steps: null
  },
  emits: ['cancel', 'burn'],
  setup(__props: any, { emit }) {

const props = __props as {
  numberToRedeem: number;
  selectedTokens: DataClientNFT[][];
  redeemTokenImage: string;
  redeemTokenName: string;
  steps: Step[];
};

const ZERO_COST_STRING = '$0.00';



const showTXSteps = ref(false);
const showCancelButton = ref(true);

const { redeemContractAddress, extensionFees, burn } = useBR();

onMounted(() => {
  updateExRate();
  exRateIntervalId.value = window.setInterval(updateExRate, 30000);
});

onUnmounted(() => {
  showTXSteps.value = false;
  showCancelButton.value = true;
  if (exRateIntervalId.value) {
    clearInterval(exRateIntervalId.value);
  }
});

/**
 * Emitters for the parent component to respond to
 */

const cancel = () => {
  showTXSteps.value = false;
  emit('cancel');
};

const confirm = () => {
  showTXSteps.value = true;
  showCancelButton.value = false;
  emit('burn');
};

/**
 * Multiplier and price logic
 */
const useFees = computed((): boolean => {
  if (extensionFees.value.set) {
    return extensionFees.value.set.toNumber() > 0;
  }
  return false;
});

const currentStepIndex = computed(() => {
  return props.steps.findIndex((s: Step) => s.status === 'current');
});

const redeemMultiplierText = computed(() => {
  if (!props.numberToRedeem) return '';
  if (isNaN(props.numberToRedeem)) return '1 ×';
  return `${props.numberToRedeem} ×`;
});

const redeemMultiplier = computed(() => {
  if (!props.numberToRedeem) return '';
  if (isNaN(props.numberToRedeem)) return 1;
  return props.numberToRedeem;
});

const pricePerToken = computed((): string => {
  if (!burn.value?.cost || !burn.value || burn.value.cost.eq(0))
    return 'FREE';

  return redeemMultiplierText.value
    + formatEther(burn.value.cost)
    + ' ETH';
});

const priceSubtotal = computed((): BigNumber => {
  if (!props.numberToRedeem || isNaN(props.numberToRedeem) || !burn.value?.cost)
    return BigNumber.from(0);
  return burn.value.cost.mul(props.numberToRedeem);
});

const priceSubtotalString = computed((): string => {
  if (!props.numberToRedeem) return '';
  if (isNaN(props.numberToRedeem)) return '';
  if (!burn.value?.cost) return ZERO_COST_STRING;
  return formatEther(priceSubtotal.value);
});

const feeSubtotal = computed((): BigNumber => {
  if (!props.numberToRedeem || isNaN(props.numberToRedeem)) return BigNumber.from(0);
  let feeToUse;

  // one group means use the normal fee, multiple groups means use the higher fee
  if (props.selectedTokens.length === 1) {
    feeToUse = BURN_FEE;
  } else {
    feeToUse = MULTI_BURN_FEE;
  }


  return feeToUse.mul(props.numberToRedeem);
});

const feeSubtotalString = computed((): string => {
  if (!props.numberToRedeem) return '';
  if (isNaN(props.numberToRedeem)) return '';
  return formatEther(feeSubtotal.value);
});

const total = computed((): BigNumber => {
  if (!props.numberToRedeem) return BigNumber.from(0);
  return priceSubtotal.value.add(feeSubtotal.value);
});

const totalString = computed((): string => {
  if (!props.numberToRedeem) return '';
  const totalAmount = total.value;
  if (totalAmount.eq(0)) return ZERO_COST_STRING;
  return formatEther(totalAmount);
});

// Exchange Rate Logic
const exRate = ref(1);
const updateExRate = async () => {
  try {
    const x = await fetch('https://api.coinbase.com/v2/prices/ETH-USD/spot', { method: 'GET' });
    if (x.status !== 200) throw new Error('Failed to fetch ETH/USD exchange rate');
    const ethToUsdJson = await x.json();
    exRate.value = parseFloat(ethToUsdJson.data.amount);
  } catch {
    // do nothing
  }
};
const exRateIntervalId = ref<number | undefined>();

// USD Price Logic
const usdPriceSubtotalString = computed((): string => {
  if (priceSubtotal.value.eq(0)) return ZERO_COST_STRING;
  if (!exRate.value) return ZERO_COST_STRING;
  return `~$${(+formatEther(priceSubtotal.value) * exRate.value).toFixed(2)}`;
});

const usdTotalString = computed((): string => {
  if (total.value.eq(0)) return ZERO_COST_STRING;
  if (!exRate.value) return ZERO_COST_STRING;
  return `~$${(+formatEther(total.value) * exRate.value).toFixed(2)}`;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, { id: "confirm-dialog" }, {
    content: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedTokens, (groupOfTokens) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupOfTokens, (bt) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "confirm-receipt-review",
                    key: bt.contractAddress + bt.tokenId
                  }, [
                    (bt.image)
                      ? (_openBlock(), _createBlock(MediaLoader, {
                          key: 0,
                          class: "confirm-receipt-thumb",
                          id: "campaign-complete-media",
                          image: bt.image,
                          media: bt.image,
                          "show-download": false,
                          "show-links": false,
                          "show-video-controls": false
                        }, {
                          error: _withCtx(() => [
                            _createTextVNode(" Failed to load the image ")
                          ]),
                          _: 2
                        }, 1032, ["image", "media"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_unref(EyeOffIcon), { class: "p-2" })
                        ])),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(bt?.name?.toUpperCase() || ('Token # ' + bt.tokenId)), 1),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(abbreviate)(bt.contractAddress)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, " × " + _toDisplayString(bt.count), 1)
                    ])
                  ]))
                }), 128))
              ], 64))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(MediaLoader, {
                class: "confirm-receipt-thumb",
                id: "campaign-complete-media",
                image: __props.redeemTokenImage,
                media: __props.redeemTokenImage,
                "show-download": false,
                "show-links": false,
                "show-video-controls": false
              }, null, 8, ["image", "media"]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(__props.redeemTokenName?.toUpperCase()), 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(abbreviate)(_unref(redeemContractAddress))), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, " × " + _toDisplayString(_unref(redeemMultiplier)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(pricePerToken)), 1)
        ]),
        (_unref(useFees))
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(feeSubtotalString)) + " ETH ", 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(useFees) ? _unref(totalString) : _unref(priceSubtotalString)) + " ETH ", 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(useFees) ? _unref(usdTotalString) : _unref(usdPriceSubtotalString)) + " USD ", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          (showTXSteps.value)
            ? (_openBlock(), _createBlock(_unref(Carousel), {
                key: 0,
                "items-to-show": 1,
                "items-to-scroll": 1,
                class: "w-full",
                "slide-width:": "300px",
                "model-value": _unref(currentStepIndex)
              }, {
                addons: _withCtx(() => [
                  _createVNode(_unref(Navigation)),
                  _createVNode(_unref(Pagination))
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.steps, (step, stepIndex) => {
                    return (_openBlock(), _createBlock(_unref(Slide), {
                      key: step.name + stepIndex
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(step.name), 1),
                        _createElementVNode("li", _hoisted_36, [
                          (step.status === 'complete')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("span", _hoisted_39, [
                                    _createElementVNode("span", _hoisted_40, [
                                      _createVNode(_unref(CheckIcon), {
                                        class: "w-5 h-5 text-black",
                                        "aria-hidden": "true"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("span", _hoisted_41, [
                                    _createElementVNode("span", _hoisted_42, _toDisplayString(step.description), 1),
                                    (step.href !== '#')
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "text-xs mt-2 font-semibold tracking-wide text-gray-400",
                                          href: step.href,
                                          target: "_blank"
                                        }, " View transaction on Etherscan ", 8, _hoisted_43))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : (step.status === 'current')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _hoisted_46,
                                    _createElementVNode("span", _hoisted_47, [
                                      _createElementVNode("span", _hoisted_48, _toDisplayString(step.description), 1),
                                      (step.href !== '#')
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "text-xs mt-2 font-semibold tracking-wide text-gray-400 w-full text-left",
                                            href: step.href,
                                            target: "_blank"
                                          }, " View your pending transaction on Etherscan ", 8, _hoisted_49))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _hoisted_52,
                                    _createElementVNode("span", _hoisted_53, [
                                      _createElementVNode("span", _hoisted_54, _toDisplayString(step.description), 1)
                                    ])
                                  ]),
                                  _createElementVNode("a", {
                                    class: "text-xs t-1 font-semibold tracking-wide text-gray-300",
                                    href: step.href,
                                    target: "_blank"
                                  }, _toDisplayString(step.href !== '#' ? 'View pending tx on Etherscan' : ''), 9, _hoisted_55)
                                ]))
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["model-value"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = () => confirm()),
                  class: "max-w-2xs confirm-button"
                }, " CONFIRM ")
              ]))
        ])
      ]),
      (showCancelButton.value)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "absolute top-3 right-3 transition-all cursor-pointer hover:opacity-80 w-6 h-6",
            onClick: _cache[1] || (_cache[1] = () => cancel())
          }, _hoisted_58))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})